var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6642 10.8785L10.9662 2.46144C10.8918 2.39727 10.7968 2.36133 10.6967 2.36133H8.42492C8.23496 2.36133 8.14768 2.59749 8.29143 2.7207L17.2809 10.5243H2.25907C2.14612 10.5243 2.05371 10.6167 2.05371 10.7296V12.2698C2.05371 12.3828 2.14612 12.4752 2.25907 12.4752H17.2784L8.28887 20.2787C8.14512 20.4045 8.23239 20.6381 8.42235 20.6381H10.7711C10.8199 20.6381 10.8687 20.6201 10.9046 20.5868L20.6642 12.1209C20.7531 12.0437 20.8243 11.9482 20.8731 11.841C20.922 11.7339 20.9472 11.6175 20.9472 11.4997C20.9472 11.382 20.922 11.2656 20.8731 11.1584C20.8243 11.0512 20.7531 10.9558 20.6642 10.8785Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.57a1e762505ddf401975c0c67fcea830.svg";
export { ForwardRef as ReactComponent };